import * as React from 'react';
import { IconProps } from './type';

export const IconPlusOutlined: React.FC<React.PropsWithChildren<IconProps>> = ({ height = 27, width = 28, className = '' }) => (
  // @ts-ignore slot attribute is required for market, but not part of the React svg type.
  <svg slot="icon" className={className} width={width} height={height} viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 27H15V14.4H27.5V12.55H15V0.0999976H13V12.55H0.45V14.4H13V27Z" fill="currentColor" />
  </svg>
);
